module.exports = __webpack_public_path__ + "static/img/y_szyx54.cfea9ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szyx54.png
// module id = ku77
// module chunks = 73